export class UpdateVaultRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateVaultRequest.attributeTypeMap;
    }
    constructor() {
    }
}
